import { Component } from '@angular/core';

@Component({
  selector: 'app-tenders-home',
  templateUrl: './tenders-home.component.html',
  styleUrls: ['./tenders-home.component.scss'],
})
export class TendersHomeComponent {}
